import { useStore } from '@nanostores/react'
import ModalWindow from 'components/molecules/ModalWindow'
import { CONSTS } from 'config/objectConst'
import { atom } from 'nanostores'

const enum ConfirmDialogMode {
	None,
	DeleteConversation,
	DeleteMessage,
	DeleteScheduleMessage
}

interface State {
	confirm?: () => Promise<any>
	mode: ConfirmDialogMode
}

const contentMap = {
	[ConfirmDialogMode.DeleteConversation]: CONSTS.confirmationDialogs['c1.15'],
	[ConfirmDialogMode.DeleteMessage]: CONSTS.confirmationDialogs[1.13],
	[ConfirmDialogMode.DeleteScheduleMessage]: CONSTS.confirmationDialogs[1.14],
	[ConfirmDialogMode.None]: CONSTS.confirmationDialogs[1.13]
}

const initial: State = { mode: ConfirmDialogMode.None }

const $confirmStore = atom<State>(initial)

const reset = () => $confirmStore.set(initial)

function ConfirmDialog() {
	const state = useStore($confirmStore)
	const isOpen = state.mode !== ConfirmDialogMode.None

	return (
		<ModalWindow
			closeHandler={reset}
			closeText='No'
			confirmHandler={() => {
				state.confirm?.()
				reset()
			}}
			confirmText='Yes'
			{...contentMap[state.mode]}
			open={isOpen}
		/>
	)
}

export { $confirmStore, ConfirmDialog, ConfirmDialogMode }
